import { Dispatch } from 'redux';
import { fetchSourceSetElement } from '../../../../services/discovery/fetchSourceSetElement';
import { makeFetchModule } from '../../../_utils';
import { storeSourceSetElements } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeSourceSetElements(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/sourceSetElementFetching',
    fetchSourceSetElement,
    callbacks
);

export default reducer;
export { fetchData, reset };
